export enum TagContentType {
  COMPANY_UPDATE = 'COMPANY_UPDATE',
  EVENT = 'EVENT',
}
